function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0953 0.0692704L7.03865 4.49107C6.73471 4.58654 6.46913 4.77647 6.28053 5.03324C6.09193 5.29001 5.99014 5.60024 5.98995 5.91883V17.1935C5.49959 17.0745 4.99705 17.0129 4.49246 17.0101C2.01225 17.0101 0 18.3512 0 20.005C0 21.6588 2.01225 23 4.49246 23C6.97267 23 8.02653 21.6588 8.02653 20.005V9.06963L20.0064 5.5599V14.199C19.5161 14.0796 19.0136 14.0178 18.5089 14.0151C16.0287 14.0151 14.0165 15.3563 14.0165 17.0101C14.0165 18.6638 16.0287 20.005 18.5089 20.005C20.9891 20.005 22.043 18.6643 22.043 17.0101V1.49609C22.0428 1.26101 21.9872 1.02928 21.8808 0.819651C21.7744 0.610027 21.6201 0.428401 21.4305 0.289472C21.2408 0.150544 21.0212 0.0582156 20.7892 0.0199603C20.5572 -0.0182949 20.3195 -0.00140258 20.0953 0.0692704Z",
  fill: "#666666"
});

var SvgIconTracksDesktop = function SvgIconTracksDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTracksDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_tracks_desktop.23f16148.svg";
export { ForwardRef as ReactComponent };